<template>
    <div ref="ScrollX">
        <slot></slot>
    </div>
</template>
<script type="text/ecmascript-6">
import BScroll from 'better-scroll'
export default {
    name: 'ScrollX',
    props: {
        probeType: {
            type: Number,
            default: 1
        },
        /**
         * 点击列表是否派发click事件
         */
        click: {
            type: Boolean,
            default: true
        },
        /**
         * 是否开启横向滚动
         */
        scrollX: {
            type: Boolean,
            default: true
        },
        /**
         * 列表的数据
         */
        data: {
            type: Array,
            default: null
        },
        /**
         * 当数据更新后，刷新scroll的延时。
         */
        refreshDelay: {
            type: Number,
            default: 20
        },
        listenBeforeScroll: {
            type: Boolean,
            default: false
        }
    },
    mounted () {
        // 保证在DOM渲染完毕后初始化better-scroll
        this.$nextTick(() => {
            setTimeout(() => {
                this._initScroll()
            }, 20)
        })
    },
    methods: {
        _initScroll () {
            if (!this.$refs.ScrollX) {
                return
            }
            // better-scroll的初始化
            this.xscroll = new BScroll(this.$refs.ScrollX, {
                probeType: this.probeType,
                click: this.click,
                scrollX: this.scrollX,
                scrollY: false
            })
            if (this.listenBeforeScroll) {
                this.xscroll.on('beforeScrollStart', () => {
                    this.$emit('beforeScrollStart')
                })
            }
        },
        disable () {
            // 代理better-scroll的disable方法
            this.xscroll && this.xscroll.disable()
        },
        enable () {
            // 代理better-scroll的enable方法
            this.xscroll && this.xscroll.enable()
        },
        refresh () {
            // 代理better-scroll的refresh方法
            this.xscroll && this.xscroll.refresh()
        },
        scrollTo () {
            // 代理better-scroll的scrollTo方法
            this.xscroll && this.xscroll.scrollTo.apply(this.xscroll, arguments)
        },
        scrollToElement () {
            // 代理better-scroll的scrollToElement方法
            this.xscroll && this.xscroll.scrollToElement.apply(this.xscroll, arguments)
        }
    },
    watch: {
        // 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
        data () {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.refresh()
                }, this.refreshDelay)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/public/ScrollX.vue